import { combineReducers } from "redux";

import auth from "./auth";
import user from './user'
import layout from "./layout";
import banner from "./banner";

export default combineReducers({ 
    auth, layout, user, banner
});